import { FONT_FAMILY_INTER, SPACING } from '@optimus-web/local-tokens';
import * as newColorSets from './colorSets';
import { FontSize, FontWeight, LineHeight } from './enums';
import textOpacityVariants from './textOpacityVariants';
import { Palette, Size, Spacing, TypographyTokens } from './types';
import { LARGE_HEIGHT, MEDIUM_HEIGHT, SMALL_HEIGHT } from './variables';

export { withTheme } from 'styled-components';

export const palette: Palette = {
    default: newColorSets.basic,
    primary: newColorSets.primary,
    info: newColorSets.info,
    disabled: newColorSets.disabled,
    error: newColorSets.error,
    success: newColorSets.success,
    warning: newColorSets.warning,
};

export const paletteDark: Palette = {
    primary: newColorSets.primaryDark,
    info: newColorSets.infoDark,
    error: newColorSets.errorDark,
    success: newColorSets.successDark,
    warning: newColorSets.warningDark,
    default: newColorSets.basicDark,
    disabled: newColorSets.disabledDark,
};

export const typography: TypographyTokens = {
    fontFamily: FONT_FAMILY_INTER,
    fontSize: {
        [FontSize.Micro]: 12,
        [FontSize.Small]: 14,
        [FontSize.Normal]: 16,
        [FontSize.SemiMedium]: 18,
        [FontSize.Medium]: 24,
        [FontSize.Large]: 30,
        [FontSize.ExtraLarge]: 36,
    },
    fontWeight: {
        [FontWeight.Light]: 300,
        [FontWeight.Regular]: 400,
        [FontWeight.Medium]: 500,
        [FontWeight.SemiBold]: 600,
        [FontWeight.Bold]: 700,
    },
    lineHeight: {
        [LineHeight.Micro]: 18,
        [LineHeight.Small]: 21,
        [LineHeight.Normal]: 24,
        [LineHeight.SemiMedium]: 27,
        [LineHeight.Medium]: 28,
        [LineHeight.Large]: 35,
        [LineHeight.ExtraLarge]: 40,
    },
    textOpacityVariants,
};

export const spacing: Spacing = {
    inputHorizontal: SPACING[200],
};

export const size: Size = {
    button: {
        heights: {
            small: SMALL_HEIGHT,
            medium: MEDIUM_HEIGHT,
            large: LARGE_HEIGHT,
        },
    },
    input: {
        heights: {
            small: SMALL_HEIGHT,
            medium: MEDIUM_HEIGHT,
            large: LARGE_HEIGHT,
        },
    },
};
